<!-- zoom -->
<template>
  <div class="mentee-zoom">
    <div class="zoom-banner-container">
      <zoom-banner :appDetail="appDetail"
                   :isPackageId="isPackageId"
                   v-if="appDetail.videoType === 'ZOOM'"></zoom-banner>
      <tencent-video :appDetail="appDetail"
                     :isPackageId="isPackageId"
                     v-if="appDetail.videoType === 'TENCENT'"></tencent-video>
    </div>
    <div>
      <zoom-detail :id="id"
                   :isPackageId="isPackageId"
                   :appDetail="appDetail"></zoom-detail>
    </div>
    <div>
      <div class="course-info" v-if="courseInfo">
        <div class="course-info-main">
          <h1>
            Course Info
          </h1>
          <ul>
            <li><div>Course Name:&nbsp; &nbsp;<span v-html="courseInfo.enName"></span></div></li>
            <li><div>Length:&nbsp; &nbsp;<span v-html="courseInfo.suggestTimeEnDesc"></span></div></li>
            <li v-show="isShow"></li>
            <template v-if="isShow">
              <li><div class="course-main"><span class="course-title-left">Detailed Instruction:&nbsp; &nbsp;</span><span v-html="courseInfo.enGuide"></span></div></li>
              <li><div class="course-main"><span class="course-title-left">Learning Objectives:&nbsp; &nbsp;</span><span v-html="courseInfo.enPurpose"></span></div></li>
              <li v-if="courseInfo.pptUrl"><div>PPT:&nbsp; &nbsp;<a :href="courseInfo.pptUrl" target="_blank">Download</a></div></li>
              <li v-if="courseInfo.systemFileUrl"><div>Comprehensive Support Course Module Guide :&nbsp; &nbsp;<a  :href="courseInfo.systemFileUrl" target="_blank">Download</a></div></li>
            </template>
            <li :class="[isShow?'dis-64':'']">
              <span @click="isShow = !isShow"
                    class="click-detail">{{isShow?'Hide details':'Show details'}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="feedback-container">
      <component :is="componentId"
                 :appDetail="appDetail"
                 :isPackageId="isPackageId"
                 @on-feedback="saveFeedback"
                 ref="component"
                 @on-confirm-success="getAppDeatil"></component>
    </div>
    <!-- 聊天 -->
    <div>
      <websocket-chat-modal></websocket-chat-modal>
    </div>
    <!-- 讨论区 -->
    <div class="mentee-zoom-dicuss">
      <div>
        <div class="mentee-zoom-dicuss-con">
          <zlr-discuss title="Other Information">
            <template v-if="commentList.length>0">
              <zlr-discuss-item v-for="(item, index) in commentList"
                                :key="index"
                                :avatar="item.avaurl || (item.createRole === 'MENTOR'? MentorAvatar: MenteeAvatar)"
                                :name="item | filterName"
                                :time="item.createTime"
                                :content="item.content"></zlr-discuss-item>
            </template>
            <zlr-empty v-else></zlr-empty>
          </zlr-discuss>
        </div>
      </div>
    </div>
    <!-- 发表讨论 -->
    <div class="mentee-zoom-add-dicuss"
         style="display:none;">
      <div>
        <div>
          <discuss-add title="Add discussion"
                       :avatar="userAvatar"
                       ref="addDisc"
                       v-model="content">
            <Button class="zlr-btn-primary"
                    @click="sendDiscussHandle"
                    :loading="isSub">Send</Button>
          </discuss-add>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getAppDeatil } from '@/api/appointment'
import { createComments, getCommentsPage } from '@/api/comments'
import { saveFeedback } from '@/api/feedback'
import { getMenteeDetail } from '@/api/mentee'
// images
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import MenteeAvatar from '@/assets/images/home/mentee-avatar.svg'
// components
import ZoomBanner from './components/zoom-banner'
import TencentVideo from './tencent/tencent-video'
import ZoomDetail from './components/zoom-detail'
import ConfirmTime from './components/confirm-time'
import discuss from '_c/discuss'
import DiscussAdd from '_c/discuss-add/discuss-add'
import Feedback1 from './components/feedback1'
import Feedback2 from './components/feedback2'
import Feedback3 from './components/feedback3'
import Feedback78 from './components/feedback78'
import FeedbackDetail from './feedback-detail'
import ZlrEmpty from '_c/empty/empty'
import { mapState } from 'vuex'
import { subSuc } from '@/constant'
import WebsocketChatModal from './tencent/websocket-chat-modal'
export default {
  name: 'mentee-zoom',
  components: {
    ZoomBanner,
    TencentVideo,
    ZoomDetail,
    ConfirmTime,
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    DiscussAdd,
    Feedback1,
    Feedback2,
    Feedback3,
    Feedback78,
    FeedbackDetail,
    ZlrEmpty,
    WebsocketChatModal
  },
  data () {
    return {
      MentorAvatar,
      MenteeAvatar,
      componentId: '',
      id: this.$route.query.id,
      appDetail: {},
      isSub: false,
      content: '',
      commentList: [],
      packageId: '',
      isPackageId: false,
      courseInfo: {},
      isShow: false
    }
  },
  computed: {
    ...mapState({
      'userAvatar' (state) {
        return state.user.userAvatar
      }
    })
  },
  created () {
    // 获取信息
    this.getMenteeDetail()
  },
  mounted () {
    this.getAppDeatil()
    this.getCommentsPage()
  },
  methods: {
    getMenteeDetail () {
      let param = {
        num: this.$route.params.id
      }
      getMenteeDetail(param).then(res => {
        if (res.code === 0) {
          if (res.data.model) {
            this.packageId = res.data.model.packageId
            if (this.packageId === 120 || this.packageId === 121) {
              this.isPackageId = true
            } else {
              this.isPackageId = false
            }
          }
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    getAppDeatil () {
      getAppDeatil({
        id: this.id
      }).then(res => {
        this.appDetail = res.data.model
        this.courseInfo = res.data.model.courseInfo
        this.mapComponents()
      })
    },
    // 获取评论列表
    getCommentsPage () {
      getCommentsPage({
        appId: this.id
      }).then(res => {
        this.commentList = res.data.page.result
      })
    },
    // 发表评论
    sendDiscussHandle () {
      if (!this.content) return false
      this.isSub = true
      createComments({
        type: 'APPOINTMENT',
        appId: this.id,
        content: this.content
      }).then(res => {
        this.$refs['addDisc'].resetHtml()
        this.getCommentsPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    mapComponents () {
      let status = this.appDetail.statu
      let modules = this.appDetail.module
      let name = ''
      if (status === 'TO_BE_COMPLETE_MENTOR') {
        name = ConfirmTime
      }
      if (status === 'TO_FEEDBACK') {
        switch (modules) {
          case 'MODULE_1':
            name = Feedback1
            break
          case 'MODULE_2':
            name = Feedback2
            break
          case 'MODULE_3':
            name = Feedback3
            break
          case 'MODULE_7':
          case 'MODULE_8':
            name = Feedback78
            break
        }
      }
      if (status === 'COMPLETE' || status === 'HAS_EVALUATE') {
        name = FeedbackDetail
      }
      this.componentId = name
    },
    // 提交feedback
    saveFeedback (data) {
      saveFeedback(data).then(() => {
        this.$zlr_message(subSuc, 'success')
        this.getAppDeatil()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.$refs['component'].handleComplete()
      })
    }
  },
  filters: {
    filterName (item) {
      let name = ''
      if (item.createRole === 'MENTOR') {
        name = item.mentorType + ' Mentor - '
        name += item.mentorName
      } else {
        name = item.menteeName
      }
      return name
    }
  }
}
</script>
<style lang='less' scoped>
.course-info{
  margin-top: 40px;
  background-color: #fff;
  .course-info-main{
    width: 1280px;
    margin: 0 auto;
    padding: 24px 0 32px 160px;
    h1{
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      font-weight: normal;
      margin-bottom: 24px;
    }
    ul li {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
    ul li>div {
      padding-bottom:7px;
    }
    .click-detail {
      padding-top:32px;
      display:inline-block;
      color: #6589dd;
      cursor: pointer;
    }
    .course-main{
      display:flex;
      .course-title-left{
        width:140px;
      }
    }
  }
}
</style>
